import React from 'react';
import { convertIcon } from '../component/Icon';
interface OverrideIconSize24 {
  size: '24';
}
type OverrideIconSize = OverrideIconSize24;

const SvgComponent = ({
  size,
  color = '#616161',
  ...rest
}: React.SVGProps<SVGSVGElement> & OverrideIconSize) => {
  if (size === '24') {
    return (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM6.58331 11.2706C6.58331 7.99541 9.00447 5.33333 12 5.33333C14.9955 5.33333 17.4166 7.99541 17.4166 11.2706V17.5204C17.4166 17.8501 16.9886 17.9551 16.8466 17.6601C16.4915 16.9228 16.0824 16.5829 15.6111 16.5829C15.3365 16.5829 15.1113 16.753 14.9259 17.061C14.8043 17.2629 14.73 17.4689 14.6993 17.5962C14.6249 17.9055 14.2045 17.914 14.1185 17.6079C14.0821 17.4781 13.9998 17.2696 13.8725 17.0649C13.6794 16.7545 13.4557 16.5829 13.2037 16.5829C12.7894 16.5829 12.4892 16.8947 12.2889 17.6079C12.2029 17.914 11.7825 17.9055 11.708 17.5962C11.5379 16.8896 11.2426 16.5829 10.7963 16.5829C10.382 16.5829 10.0818 16.8947 9.88146 17.6079C9.79549 17.914 9.3751 17.9055 9.30063 17.5962C9.13052 16.8896 8.83519 16.5829 8.38887 16.5829C7.91756 16.5829 7.50842 16.9228 7.1534 17.6601C7.01138 17.9551 6.58331 17.8501 6.58331 17.5204V11.2706ZM9.49997 11.1667C9.96021 11.1667 10.3333 10.7936 10.3333 10.3333C10.3333 9.87309 9.96021 9.5 9.49997 9.5C9.03973 9.5 8.66664 9.87309 8.66664 10.3333C8.66664 10.7936 9.03973 11.1667 9.49997 11.1667ZM15.3333 10.3333C15.3333 10.7936 14.9602 11.1667 14.5 11.1667C14.0397 11.1667 13.6666 10.7936 13.6666 10.3333C13.6666 9.87309 14.0397 9.5 14.5 9.5C14.9602 9.5 15.3333 9.87309 15.3333 10.3333Z"
          fill={color}
        />
      </svg>
    );
  }
  return <div></div>;
};
/**
 * 컬러 주입 가능여부: 가능,
 * 기본컬러:#616161
 * 사용가능한 사이즈는 24 입니다.
 * 20(디폴트)사이즈가 없으므로 size prop은 required 입니다.
 */
const IconComponent = convertIcon<OverrideIconSize>(SvgComponent, 'ghost');
export default IconComponent;
